// extracted by mini-css-extract-plugin
module.exports = {"comp":"I_comp__Dx8JL"};